export type OnboardingStep = {
  id: string;
  title: string;
  description: string;
  /** CSS selector for the element the card points at. `index` picks among multiple matches. */
  target: string;
  index?: number;
  /** Point at the centre of the target instead of its edge (used for the 3D model). */
  center?: boolean;
  /** UI state the step needs: which tool panel is open and whether History is open. */
  tool: 'protect' | 'support' | null;
  history: boolean;
};

export const onboardingSteps: OnboardingStep[] = [
{
  id: 'protect',
  title: 'Introducing Protect',
  description:
  'Mark surfaces that must stay clean and PreForm will prioritise keeping supports off them. Auto-Orient, auto-generated supports and 1-Click Print all take your protected areas into account.',
  target: '[data-onboard="tool-protect"]',
  tool: null,
  history: false
},
{
  id: 'paint',
  title: 'Paint protected surfaces',
  description: 'Click and drag across the model to paint the areas you want protected. Made a mistake? Switch to Erase and brush over it.',
  target: '[data-onboard="viewport"]',
  center: true,
  tool: 'protect',
  history: false
},
{
  id: 'ai',
  title: 'Or explain it with words',
  description: 'Describe the areas in your own words, like “gear teeth” or “the logo face”, and let AI select the relevant surfaces for you.',
  target: 'input[aria-label="Describe areas to protect"]',
  tool: 'protect',
  history: false
},
{
  id: 'profiles',
  title: 'Introducing Support Profiles',
  description: 'Save extra time by storing your support settings as custom profiles for similar parts, or start from one of our smart presets.',
  target: 'button[aria-label^="Support profile:"]',
  tool: 'support',
  history: false
},
{
  id: 'history',
  title: 'Introducing Project History',
  description: 'Keep track of every change and save important moments while you prepare your print.',
  target: 'button[title="History"]',
  tool: null,
  history: false
},
{
  id: 'restore',
  title: 'Restore a previous version',
  description: 'Go back to an important moment and fix mistakes by restoring the model to an earlier state from this menu.',
  target: '[data-onboard="history-panel"] [aria-label^="Actions for"]',
  index: 2,
  tool: null,
  history: true
},
{
  id: 'export',
  title: 'New export options',
  description: 'You can now export models as STL, OBJ and 3MF files straight from PreForm, right from this menu.',
  target: 'ul[aria-label="Models in build"] [aria-label^="Actions for"]',
  tool: null,
  history: false
}];
